import $ from 'jquery';

export const elements = {
    nav: '.js-TabsBox-Navigation span',
    holder: '.js-TabsBox-Holder',
    box: '.js-TabsBox-Box',
};

export const onClick = function () {
    const $this = $(this);

    const index = $this.index();
    const $holder = $this.parents(elements.holder);
    const $box = $holder.find(elements.box);
    const $tab = $box.find('article');
    const $nav = $holder.find(elements.nav);

    $nav.removeClass('fn-active');
    $this.addClass('fn-active');

    $tab.removeClass('fn-visible');
    $tab.eq(index).addClass('fn-visible');
};

export default {
    init(params) {
        params.$document.on('click', elements.nav, onClick);
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/tabs-box.js